import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import { siteStats, mediaReviews } from '@/mocks/comics';

export default function About() {
  const aboutTitle = '关于我们 - 韩国漫画网 - 韩漫大全在线阅读平台';
  const aboutDesc = '韩国漫画网是一个专注于韩国漫画在线阅读的中文平台，提供海量韩漫免费阅读，下拉式全集在线浏览，每日更新，分类清晰。了解我们的品牌故事与愿景。';
  const aboutKeywords = '韩国漫画网,关于我们,韩漫大全,免费漫画平台,品牌介绍';

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于韩国漫画网',
    description: aboutDesc,
    about: {
      '@type': 'Organization',
      name: '韩国漫画网',
      description: '韩国免费漫画在线阅读平台，提供韩漫大全面向中文读者的优质阅读服务。',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩国漫画网的漫画是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，韩国漫画网上的所有韩漫作品均提供免费在线阅读。我们致力于为中文读者提供正版、免费、高质量的韩国漫画阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '韩国漫画网的作品有版权吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩国漫画网高度重视版权保护，与多家韩国漫画工作室建立了正式合作关系，所有上线作品均获得正版授权。我们尊重创作者的权益，为读者提供合法合规的阅读渠道。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在韩国漫画网找到想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页的分类导航（恋爱、奇幻、动作、惊悚、耽美、剧情等）浏览不同类型的韩漫，也可以使用搜索功能直接查找作品名称。首页每日更新板块让您第一时间发现最新内容。',
        },
      },
      {
        '@type': 'Question',
        name: '什么是下拉式漫画阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '下拉式阅读是韩国漫画网的核心阅读体验，漫画内容以上下滑动的方式连续呈现，无需翻页，阅读体验流畅自然。这种格式专为手机和网页阅读优化，让您沉浸在漫画世界中。',
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title={aboutTitle}
        description={aboutDesc}
        keywords={aboutKeywords}
        canonicalPath="/about"
        schema={aboutSchema}
      />
      <Navbar />

      <main>
        <section className="relative w-full h-[360px] md:h-[480px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20modern%20creative%20office%20space%20with%20soft%20coral%20and%20cream%20tones%2C%20artistic%20illustration%20on%20walls%2C%20warm%20natural%20lighting%2C%20clean%20minimal%20design%2C%20korean%20webtoon%20brand%20studio%20atmosphere%2C%20comfortable%20and%20inspiring&width=1800&height=900&seq=hero-about-2026&orientation=landscape"
            alt="关于韩国漫画网 - 品牌介绍"
            title="韩国漫画网品牌"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/60"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
            <nav className="mb-4 text-xs md:text-sm text-white/70" aria-label="面包屑导航">
              <Link to="/" className="hover:text-white transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <span className="mx-2">/</span>
              <span className="text-white">关于我们</span>
            </nav>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-3 md:mb-4">
              关于韩国漫画网
            </h1>
            <p className="text-sm md:text-base text-white/80 max-w-xl leading-relaxed">
              为中文读者打造最优质的韩漫阅读体验
            </p>
          </div>
        </section>

        <section id="brand" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              <div>
                <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-4">
                  品牌简介
                </span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
                  关于我们
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    韩国漫画网成立于2020年，是国内领先的<strong>韩国漫画在线阅读平台</strong>。我们致力于为中文读者提供海量、优质、正版的韩国漫画（韩漫）内容，涵盖恋爱、奇幻、动作、惊悚、耽美、剧情等多种题材，满足不同读者的阅读偏好。
                  </p>
                  <p>
                    我们与多家韩国知名漫画工作室建立了<strong>正式版权合作关系</strong>，确保所有上线作品均获得合法授权。平台采用先进的<strong>下拉式阅读技术</strong>，为读者提供流畅、沉浸式的漫画阅读体验，无论是在电脑还是手机上都能享受最佳阅读效果。
                  </p>
                  <p>
                    我们的团队由热爱漫画的编辑、技术工程师和运营人员组成，秉持&ldquo;让每个人都能自由享受漫画乐趣&rdquo;的理念，每日同步韩国更新进度，第一时间为读者带来最新鲜的漫画内容。
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 md:gap-6">
                <div className="bg-background-50 rounded-xl p-5 md:p-6 text-center">
                  <p className="text-3xl md:text-4xl font-bold text-primary-500">{siteStats.totalComics}</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-2">漫画总数</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 md:p-6 text-center">
                  <p className="text-3xl md:text-4xl font-bold text-primary-500">{siteStats.totalUsers}</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-2">累计用户</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 md:p-6 text-center">
                  <p className="text-3xl md:text-4xl font-bold text-primary-500">{siteStats.dailyActive}</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-2">日活跃用户</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 md:p-6 text-center">
                  <p className="text-3xl md:text-4xl font-bold text-primary-500">{siteStats.countries}</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-2">覆盖国家</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-3">
                <i className="ri-award-fill text-accent-500"></i> 媒体评价
              </span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                行业口碑
              </h2>
              <p className="mt-2 text-sm text-foreground-600">来自媒体与行业的声音</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {mediaReviews.map((review) => (
                <div key={review.id} className="bg-background-100 rounded-xl p-5 md:p-6 flex flex-col">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                      <i className="ri-double-quotes-l text-accent-500"></i>
                    </span>
                    <p className="text-sm font-semibold text-foreground-950">{review.source}</p>
                  </div>
                  <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1">
                    &ldquo;{review.content}&rdquo;
                  </blockquote>
                  <p className="mt-4 text-xs text-foreground-500">{review.date}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="relative w-full py-16 md:py-24 px-4 md:px-6 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20coral%20and%20gold%20gradient%20abstract%20background%2C%20soft%20elegant%20flowing%20shapes%2C%20professional%20yet%20warm%20atmosphere%2C%20clean%20minimal%20composition%2C%20korean%20webtoon%20brand%20contact&width=1600&height=700&seq=cta-about-2026&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/55"></div>
          <div className="relative z-10 text-center max-w-[700px] mx-auto">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
              合作与联系
            </h2>
            <p className="text-sm md:text-base text-white/80 mb-8 max-w-md mx-auto leading-relaxed">
              欢迎版权合作、商务洽谈与媒体联系。让我们一起为读者带来更好的漫画体验。
            </p>
            <a
              href="mailto:hello@bendionline.com"
              className="inline-flex items-center gap-2 px-10 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              联系我们
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line"></i>
              </span>
            </a>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}